import {
  LOADING_SHOW,
  LOADING_HIDE,
} from '../../constants/actionTypes';

const INITIAL_STATE = {
  isVisible: false,
};

const applyShowLoading = (state, action) => ({
  isVisible: true,
});

const applyHideLoading = (state, action) => ({
  isVisible: false,
});

const loadingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LOADING_SHOW:
      return applyShowLoading(state, action);
    case LOADING_HIDE:
      return applyHideLoading(state, action);
    default:
      return state;
  }
};

export default loadingReducer;
